import React, { type ReactNode } from 'react';
import { StyleSheet } from 'react-native';

import { Container, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ReorderRailHeader = (props: Props) => {
  const { children } = props;

  return <Container style={styles.row}>{children}</Container>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children?: ReactNode;
};
